import type { PayApp } from '../../api/types'
import { formatUsd } from './pulseTotals.js'
import PulsePaymentsSection from './PulsePaymentsSection'
import type { PulsePaymentRow, PulsePaymentsPayload } from './pulseApi'

export default function PulsePaymentsPanel({
  apps,
  payments,
  highlight,
  onOpenPayApp,
  onOpenPayment,
}: {
  apps: PayApp[]
  payments?: PulsePaymentsPayload | null
  highlight?: 'received' | 'retainage'
  onOpenPayApp: (id: number) => void
  onOpenPayment: (row: PulsePaymentRow) => void
}) {
  if (highlight === 'received') {
    return <PulsePaymentsSection payload={payments} onOpen={onOpenPayment} />
  }
  const rows = apps.filter((pa) => {
    if (pa.deleted_at) return false
    if (highlight === 'retainage') return Boolean(pa.is_retainage_release)
    return true
  })
  return (
    <div data-testid="pulse-payments-panel" data-highlight={highlight || ''}>
      {highlight === 'retainage' ? null : <PulsePaymentsSection payload={payments} onOpen={onOpenPayment} />}
      <ul className="pulse-pay-list">
        {rows.map((pa) => (
          <li key={pa.id}>
            <button
              type="button"
              className="pulse-row"
              data-testid={`pulse-drawer-pa-${pa.id}`}
              onClick={() => onOpenPayApp(pa.id)}
            >
              <span>PA {pa.app_number ?? pa.id}</span>
              <span>{formatUsd(pa.amount_due)}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
